"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serializable = void 0;
const class_transformer_1 = require("class-transformer");
const class_transformer_validator_1 = require("class-transformer-validator");
const defaultTransformValidationOptions = {
    validator: {
        forbidUnknownValues: true,
    },
};
class Serializable {
    toJSON() {
        return (0, class_transformer_1.instanceToPlain)(this);
    }
    static fromObject(src) {
        return (0, class_transformer_validator_1.transformAndValidateSync)(this, src, defaultTransformValidationOptions);
    }
    static fromJSON(src) {
        const transformed = (0, class_transformer_validator_1.transformAndValidateSync)(this, src, defaultTransformValidationOptions);
        if (Array.isArray(transformed)) {
            throw new Error('Expected a single instance from JSON string but got an array');
        }
        return transformed;
    }
    static fromPlain(src) {
        return Object.assign(new this(), src);
    }
    static fromJSONArray(src) {
        const transformed = (0, class_transformer_validator_1.transformAndValidateSync)(this, src, defaultTransformValidationOptions);
        if (!Array.isArray(transformed)) {
            throw new Error('Expected an array from JSON string instance but got a single instance');
        }
        return transformed;
    }
}
exports.Serializable = Serializable;
